import css from 'styled-jsx/css';
import { pageWidth } from 'styles/css-constants';

/*
Overview
--------
Minidisc displays from 1 to 4 items in a contained layout that goes from
a single column for small screens (mobile) to one large item on top of the
other items (tablet) to one large item that sits next to the other
items (desktop). Unlike other layouts, there is no space between the items.
In all cases, the layout accounts for a single ad item to be rendered
after the other items.
*/
const largeGridColumn = 952 / 12;
const midlargeGridColumn = 1124 / 12;

export default css`
  .Spread__item {
    margin-bottom: 1.5rem;
  }

  @media (max-width: 47.99rem) {
    .Spread__item--ad {
      padding: 0 0.5rem;
    }
  }

  @media (min-width: 48rem) and (max-width: 63.99rem) {
    .Spread__items {
      padding: 0 1.5rem;
    }
  }

  @media (min-width: 48rem) {
    .Spread__item--ad {
      margin-bottom: 0;
    }

    .Spread__items {
      padding: 0 1.5rem;
    }
  }

  @media (min-width: 64rem) {
    .Spread__items {
      flex-flow: column wrap;
    }

    .Spread__item--0 {
      flex: 0 0 100%;
      margin-right: 1.5rem;
      width: ${largeGridColumn * 7}px;
    }

    .Spread__item--1,
    .Spread__item--2,
    .Spread__item--3 {
      width: ${largeGridColumn * 5}px;
    }

    .Spread__item--ad {
      padding-top: 1.5rem;
    }

    .Spread__items {
      width: ${pageWidth.large};
      /* Magic number */
      height: 550px;
      padding: 0;
      margin: 0 auto;
    }
  }

  @media (min-width: 75rem) {
    .Spread__items {
      height: 700px;
    }
  }

  @supports (display: grid) {
    @media (min-width: 48rem) {
      .Spread__items {
        display: grid;
        grid-template:
          '.  main  .'
          '.  two   .'
          '.  three .'
          '.  four  .'
          '.  five  .'
          'ad ad    ad'
          / 0fr 1fr 0fr;
        grid-column-gap: 1.5rem;
        height: auto;
        padding: 0;
      }

      .Spread__item--0.Spread__item--teaser {
        grid-area: main;
      }

      .Spread__item--1.Spread__item--teaser {
        grid-area: two;
      }

      .Spread__item--2.Spread__item--teaser {
        grid-area: three;
      }

      .Spread__item--3.Spread__item--teaser {
        grid-area: four;
      }

      .Spread__item--4.Spread__item--teaser {
        grid-area: five;
      }

      .Spread__item--ad {
        grid-area: ad;
      }
    }

    @media (min-width: 64rem) {
      .Ad > div {
        margin-top: 1.5rem;
      }

      .Spread__item {
        margin-bottom: 0;
      }

      .Spread__item--0,
      .Spread__item--1,
      .Spread__item--2,
      .Spread__item--3 {
        width: auto;
      }

      .Spread__item--0 {
        margin-right: 0;
      }

      .Spread__items {
        margin: 0;
        grid-template:
          '.  main two   .' max-content
          '.  main three .' max-content
          '.  main four  .' max-content
          '.  main five  .' minmax(auto, min-content)
          'ad ad   ad    ad'
          / 1fr ${largeGridColumn * 7}px ${largeGridColumn * 5}px 1fr;
        grid-template-rows: -webkit-max-content -webkit-max-content -webkit-max-content minmax(
            auto,
            -webkit-min-content
          );
        grid-column-gap: 1.5rem;
        grid-row-gap: calc(1.5rem / 2);
        height: auto;
        width: 100%;
      }
    }

    @media (min-width: 75rem) {
      .Spread__items {
        grid-template-columns: 1fr ${midlargeGridColumn * 7}px ${midlargeGridColumn *
            5}px 1fr;
        height: auto;
      }
    }
  }
`;
